<div class="page-content">
  <!-- inner page banner -->
  <!-- <div class="dez-bnr-inr overlay-black-middle" style="background-image:url(assets/images/bg4.jpg);">
    <div class="container">
      <div class="dez-bnr-inr-entry">
        <h1 class="text-white">Noticias</h1>
      </div>
    </div>
  </div> -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Noticias</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <div class="content-area">
    <!-- Left & right section start -->
    <div class="container">
      <div class="p-a30 bg-white m-b30">
        <div class="section-head inner-haed">
          <h2 class="text-uppercase">Noticias</h2>
        </div>
        <div class="section-content">
          <div class="row">
            <div *ngFor="let item of noticias;let i = index;" class="col-md-4 col-sm-4 m-b30">
              <div class="dez-box p-a20 border-1">
                <div class="dez-media"> <a routerLink="/noticia/{{item.id}}"><img src="{{domain}}{{item.imagen}}"
                      alt=""></a> </div>
                <div class="dez-info">
                  <h4 class="dez-title m-t20"><a routerLink="/noticia/{{item.id}}">{{item.titulo}}</a></h4>
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li>
                <a (click)="getNoticias(0)" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li *ngFor="let item of pages"><a href="javascript:;" (click)="getNoticias(item)">{{item+1}}</a></li>
              <li>
                <a (click)="getNoticias(t)" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <!-- Left & right section  END -->
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/components/more-news/more-news.component.html